import { useSession } from "../../hooks/useSession";
import { Add, Park } from "@mui/icons-material";
import Layout from "../../layout";
import CollectionList from "./components/CollectionList";
import Link from "../../components/Link";
import { useCollections } from "../../hooks/useCollectionList";
import Loading from "../../components/Loading";
import PageHeader from "../../components/PageHeader";
import { readScratchCollection } from "../../utils/scratch";

export default function HomePage() {
  const { profile } = useSession();
  const { collections } = useCollections();

  const scratchCollection = readScratchCollection();

  if (!profile || !collections) {
    return (
      <Layout>
        <Loading label="Carregando avaliações…" />
      </Layout>
    );
  }

  const listed = scratchCollection
    ? [scratchCollection, ...collections]
    : collections;
  const isEmpty = listed.length === 0;

  return (
    <Layout>
      <PageHeader
        title="Avaliações recentes"
        description="Acompanhe as coletas e continue um rascunho ou registre uma nova praça."
        actions={
          !isEmpty ? (
            <Link
              className="!w-fit"
              variant="contained"
              color="primary"
              to="/avaliacoes/criar"
            >
              <Add aria-hidden="true" />
              Nova avaliação
            </Link>
          ) : undefined
        }
      />

      <CollectionList
        collections={listed}
        emptyIcon={<Park />}
        emptyTitle="Nenhuma avaliação ainda"
        emptyDescription="Comece cadastrando a praça visitada. O rascunho é salvo automaticamente enquanto você preenche."
      />
    </Layout>
  );
}
